<template>
  <div>
    <div class="topBox">
        <div class="sideList">
          <img src="../assets/left.png" @click="linkBack()" />
        </div>
        <div class="mainList">{{msg}}</div>
        <div class="sideList">
         
        </div>
      </div>
      <div class="topH"></div>
  </div>
</template>

<script>
export default {
  data(){
   return {}
  },
  methods:{
    linkBack(){
      var _this=this;
      this.$router.go(_this.pageNum);
    },
  },
  name: 'TopBar',
  props: {
    msg: String,
    pageNum:Number
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.topBox {
  width: 375px;
  height: 44px;
  background-color: #444444;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  align-content: center;
  justify-content: space-between;
}
.topH {
  height: 44px;
}
.sideList {
  width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sideList img {
  width: 18px;
  height: 18px;
  margin-right: 30px;
}
.mainList {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: white;
}
.addBtn {
  background: #e62129;
  color: white;
  border-radius: 5px;
  font-size: 10px;
  padding: 3px 8px;
}
</style>
